var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyBoldChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Chat",
    "data-name": "Iconly/Bold/Chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M9.98,0a10,10,0,1,0,4.94,18.7,1.7,1.7,0,0,1,1.49-.361h0l2.02.6a.625.625,0,0,0,.82-.781h0l-.67-2.243a1.049,1.049,0,0,1,.07-.9,10.588,10.588,0,0,0,1.35-5A10.007,10.007,0,0,0,9.98,0ZM5.41,8.743a1.282,1.282,0,1,1-1.28,1.282A1.277,1.277,0,0,1,5.41,8.743Zm4.61,0a1.275,1.275,0,0,1,1.28,1.272,1.28,1.28,0,1,1-2.56.01A1.277,1.277,0,0,1,10.02,8.743Zm4.61,0a1.277,1.277,0,0,1,1.28,1.282,1.28,1.28,0,1,1-2.56,0A1.277,1.277,0,0,1,14.63,8.743Z",
    fill: "#446fa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldChat);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Chat.27591c3ba40aedaae60f6e234b1a3341.svg";
export { ForwardRef as ReactComponent };